export default "__VITE_ASSET__dda6a746__"